export default {
  server: 'https://aag.davidz.ca/server.php?url='
}
